import localStorage from 'local-storage';
import { handleFetchResponse } from '@cotyorg/ccx-utils/js/helpers/handleFetchResponse';
import debounce from '@cotyorg/ccx-utils/js/helpers/debounce';
import generateUUID from '@cotyorg/ccx-utils/js/helpers/uuid';
import {
  FETCH_SEARCH_SUCCESS,
  UPDATE_SEARCH,
  CLEAR_SEARCH,
  SET_HISTORY,
  SET_HISTORY_LOADED,
} from './types';
import buildSearchUrl from '../helpers/build-search-url';

const localStorageKey = 'ccx:historyResults';

export const updateSearch = term => ({ type: UPDATE_SEARCH, term });

export const clearSearch = () => ({ type: CLEAR_SEARCH });

export const setHistoryLoaded = () => ({ type: SET_HISTORY_LOADED });

export const setHistory = searchTermHistory => ({ type: SET_HISTORY, searchTermHistory });

const debouncedUpdateSearchHistory = debounce(
  (dispatch, getState, term) => {
    const {
      search: {
        searchTermHistory = [],
      } = {},
    } = getState();

    const containsTerm = !!searchTermHistory.find(({ title }) => title === term);
    const historyItem = { title: term, uid: generateUUID() };

    if (!containsTerm) {
      const newSearchTermHistory = [historyItem, ...searchTermHistory];
      dispatch(setHistory(newSearchTermHistory));
      localStorage.set(localStorageKey, newSearchTermHistory);
    }
  },
  1000,
);

export const updateSearchHistory = term => (dispatch, getState) => (
  debouncedUpdateSearchHistory(dispatch, getState, term)
);

export const fetchSearchResults = ({
  value,
  searchURL,
  locale,
}) => (dispatch) => {
  dispatch(updateSearch(value));

  if (value.length >= 3 && searchURL && locale) {
    return fetch(buildSearchUrl({
      value,
      searchURL,
      locale,
    }))
      .then(handleFetchResponse)
      .then((response) => {
        if (response.entries && response.entries.length) {
          dispatch(updateSearchHistory(value));
          dispatch({
            type: FETCH_SEARCH_SUCCESS,
            results: response.entries,
          });
        }
      })
      // eslint-disable-next-line no-console
      .catch(err => console.error(err));
  }

  return Promise.resolve();
};

export const loadSearchHistory = () => (dispatch, getState) => {
  const {
    search: {
      searchHistoryLoaded,
    } = {},
  } = getState();

  const searchTermHistory = localStorage.get(localStorageKey);

  if (!searchHistoryLoaded) {
    dispatch(setHistoryLoaded());
    dispatch(setHistory(searchTermHistory));
  }
};

export const clearSearchHistory = () => (dispatch) => {
  localStorage.remove(localStorageKey);
  dispatch(setHistory([]));
};
